import { useEffect, useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Products from './components/Products';
import Features from './components/Features';
import Contact from './components/Contact';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="w-full px-20 py-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <img src="https://public.readdy.ai/ai/img_res/946c6096-d0b3-46bd-9556-bc1053c0268e.png" alt="LILA SH.P.K. Logo" className="h-10 w-10 object-contain" />
              <h1 className={`text-lg font-medium transition-colors ${scrolled ? 'text-gray-900' : 'text-white'}`}>
                LILA SH.P.K.
              </h1>
            </div>
            <div className="flex items-center gap-12">
              <button onClick={() => scrollToSection('home')} className={`text-sm font-light transition-colors hover:opacity-70 whitespace-nowrap ${scrolled ? 'text-gray-900' : 'text-white'}`}>
                Home
              </button>
              <button onClick={() => scrollToSection('about')} className={`text-sm font-light transition-colors hover:opacity-70 whitespace-nowrap ${scrolled ? 'text-gray-900' : 'text-white'}`}>
                About
              </button>
              <button onClick={() => scrollToSection('products')} className={`text-sm font-light transition-colors hover:opacity-70 whitespace-nowrap ${scrolled ? 'text-gray-900' : 'text-white'}`}>
                Products
              </button>
              <button onClick={() => scrollToSection('contact')} className={`text-sm font-light transition-colors hover:opacity-70 whitespace-nowrap ${scrolled ? 'text-gray-900' : 'text-white'}`}>
                Contact
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Sections */}
      <Hero />
      <About />
      <Products />
      <Features />
      <Contact />
    </div>
  );
}